var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ loading: _vm.loading },attrs:{"disabled":_vm.loading || _vm.disabled},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"text"},[_vm._t("default")],2),(_vm.loading)?_c('SpinnerOct',{staticClass:"spinner",attrs:{"opaque":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }